import { EmitterConfig } from '@mos/client/shared/canvas/models/emitter.config'
import { ParticleStarUi } from '@mos/client/shared/canvas/models/presets'
import { getParticleDirectionFromCenter } from '@mos/client/shared/canvas/models/utils'
import { Area, Rectangles } from '@mos/client/shared/utils'
import { randomInRange } from '@mos/shared/utils'

function getButtonBorderArea(rectangle: Area, margin = 20, borderDistance = 0): Rectangles {
	return [
		// Top
		{ x: margin, y: margin - borderDistance, width: rectangle.width - 2 * borderDistance, height: borderDistance },
		// Right
		{
			x: rectangle.width - margin,
			y: margin,
			width: borderDistance,
			height: rectangle.height - 2 * margin,
		},
		// Bottom
		{
			x: margin,
			y: rectangle.height - margin,
			width: rectangle.width - 2 * borderDistance,
			height: borderDistance,
		},
		// Left
		{ x: margin - borderDistance, y: margin, width: borderDistance, height: rectangle.height - 2 * margin },
	]
}

export const particleConfig: EmitterConfig = {
	...ParticleStarUi,
	spawnRate: 10,
	displayArea: { width: 300, height: 100 },
	spawnArea: (particle) => getButtonBorderArea(particle.displayArea, 20, 8),
	velocityX: () => randomInRange(-0.01, 0.01),
	velocityY: () => randomInRange(-0.01, 0.01),
	velocityAlpha: () => randomInRange(0.00015, 0.0004),
}

export const burstParticleConfig: EmitterConfig = {
	...particleConfig,
	ttl: () => 2000,
	spawnRate: 0,
	spawnArea: (particle) => getButtonBorderArea(particle.displayArea, 20, 3),
	velocityAlpha: () => 0.0008,
	velocityY: (particle) => getParticleDirectionFromCenter(particle).y * 0.05,
	velocityX: (particle) => getParticleDirectionFromCenter(particle).x * 0.05,
}
